import type { HoverActionIconProps, PropertyIconProps } from "../types/IconProps";
// Find Icons in both property and hover icons for hovering. if a property icon is only in hover actions, always show the hover action and hide the property icon
export default function findIconKeyIntersectionSet(hoverActionIcons: HoverActionIconProps[], propertyIcons: PropertyIconProps[], isSingleLine: boolean, hoverFlagIndex?: number, hoverPinIndex?: number, propFlagIndex?: number, propPinIndex?: number): Set<unknown> | null {
    // if we are in SCL, there are no hover actions, or no property icons return null
    if (!isSingleLine ||
        !hoverActionIcons ||
        hoverActionIcons.length === 0 ||
        !propertyIcons ||
        propertyIcons.length === 0) {
        return null;
    }
    
    const keyIntersectionSet = new Set();
    // Helper function to check if indices are valid and keys match
    const checkIconMatch = (hoverIndex: number, propIndex: number): string | null => {
        if (hoverIndex > -1 &&
            propIndex > -1 &&
            hoverIndex < hoverActionIcons.length &&
            propIndex < propertyIcons.length &&
            hoverActionIcons[hoverIndex]?.key &&
            propertyIcons[propIndex]?.key &&
            hoverActionIcons[hoverIndex].key === propertyIcons[propIndex].key) {
            return propertyIcons[propIndex].key;
        }
        return null;
    };
    
    // Check if flag hover action exists and property icon exists
    const flagKey = checkIconMatch(hoverFlagIndex ?? -1, propFlagIndex ?? -1);
    
    if (flagKey) {
        keyIntersectionSet.add(flagKey);
    }
    
    // Check if pin hover action exists and property icon exists
    const pinKey = checkIconMatch(hoverPinIndex ?? -1, propPinIndex ?? -1);
    if (pinKey) {
        keyIntersectionSet.add(pinKey);
    }
    return keyIntersectionSet;
}
